export const ehypLinks: {
    interestCalculatorUrl: string; // Persönlicher Zinsrechner
    mortgageRequestUrl: string; // Online-Antrag
} = {
    interestCalculatorUrl:
        'https://www.ehyp.de/angular/calcpac/interest-calculator?cst.id.cryptUltd=30901896w3l6-5fp1vgl40i9eyeyxwn88or2g257',
    mortgageRequestUrl: 'https://www.ehyp.de/angular/calcpac/mortgage-request?cst.id.cryptUltd=30901896w3l6-5fp1vgl40i9eyeyxwn88or2g257',
};
